"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocale = exports.getNextEventFromNow = exports.getOrdinalFromNumber = exports.getWeekDayFromTime = exports.getTimeNow = exports.getTime = exports.formatTimeWithNumerals = exports.formatTime = void 0;
var date_helpers_1 = require("./date.helpers");
var event_helpers_1 = require("./event.helpers");
exports.formatTime = date_helpers_1.FORMAT_TIME;
exports.formatTimeWithNumerals = date_helpers_1.FORMAT_TIME_WITH_NUMERALS;
// getters
exports.getTime = date_helpers_1.GET_TIME;
exports.getTimeNow = date_helpers_1.GET_TIME_NOW;
exports.getWeekDayFromTime = date_helpers_1.GET_WEEKDAY_FROM_TIME;
exports.getOrdinalFromNumber = date_helpers_1.GET_ORDINAL_FROM_NUMBER;
exports.getNextEventFromNow = event_helpers_1.GET_NEXT_EVENT_FROM_NOW;
// setters
exports.setLocale = date_helpers_1.SET_LOCALE;
